import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
  const location = useLocation();
  const { role } = useAuth();
  let content;

  if (allowedRoles.includes(role)) {
    content = <Outlet />;
  } else {
    content = (
      <Navigate to="/login" state={{ from: location }} replace />
    );
  }

  return content;
};

export default RequireAuth;
